import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {TableType9} from '../../_models';
import {Data} from '../../_providers';
import {Observable, BehaviorSubject} from 'rxjs';


export class Type9DataSource implements DataSource<TableType9> {
  // {
  // driver:'',
  // date: '',
  // hourWorked: ,
  // actionTaken: 'YES\NO',
  // comments:''
  // },

  filter = '';
  sortDirection = 'asc';
  pageIndex = 0;
  pageSize = 7;
  private tableData: any;
  private tableDisplayData = new BehaviorSubject<TableType9[]>([]);

  public constructor(private data: Data, private tableID: number) {
    this.tableData = data.getTableById(tableID); /// TODO maybe data validation
    if (Object.keys(this.tableData.table_data).length === 0) {
      this.tableData.table_data = [];
    }
    if (this.tableData.table_data.length < 10) {
      for (let i = this.tableData.table_data.length; i < 10; i++) {
        const tempObj: any = {};
        tempObj.driver = '';
        tempObj.date = '';
        tempObj.hourWorked = '';
        tempObj.actionTaken = '';
        tempObj.comments = '';
        this.tableData.table_data.push(tempObj);
      }
    }
  }

  dataLength() {
    return this.tableData.table_data.length; // TODO maybe needs to change
  }

  connect(collectionViewer: CollectionViewer): Observable<TableType9[]> {
    return this.tableDisplayData.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.tableDisplayData.complete();
  }

  loadData(filter = this.filter, sortDirection = this.sortDirection, pageIndex = this.pageIndex, pageSize = this.pageSize) {
    this.filter = filter;
    this.sortDirection = sortDirection;
    this.pageIndex = pageIndex;
    this.pageSize = pageSize;


    const tempData: TableType9[] = [];
    for (let i = pageIndex * pageSize;
      i < this.tableData.table_data.length && i < (pageIndex + 1) * pageSize;
      i++) {
      const tempObj: any = {};
      tempObj.id = i;
      tempObj.driver = this.tableData.table_data[i].driver;
      tempObj.date = this.tableData.table_data[i].date;
      tempObj.hourWorked = this.tableData.table_data[i].hourWorked;
      tempObj.actionTaken = this.tableData.table_data[i].actionTaken;
      tempObj.comments = this.tableData.table_data[i].comments;

      tempData.push(tempObj);
    }

    this.tableDisplayData.next(tempData);
  }


  updateDriver(index: number, driver: string) {
    this.tableData.table_data[index].driver = driver;
    this.data.pushTableUpdate(this.tableData.id);
  }

  updateDate(index: number, newDate: Date) {
    this.tableData.table_data[index].date = newDate.toISOString();
    this.data.pushTableUpdate(this.tableData.id);
  }

  updateHourWorked(index: number, hourWorked: string) {
    this.tableData.table_data[index].hourWorked = hourWorked;
    this.data.pushTableUpdate(this.tableData.id);
  }

  updateActionTaken(index: number, actionTaken: string) {
    this.tableData.table_data[index].actionTaken = actionTaken;
    // this.loadData();//attempted as a quick fix for the form to show number don't work TODO look into turning the form red, with form
    // control
    this.data.pushTableUpdate(this.tableData.id);
  }

  updateComments(index: number, comments: string) {
    this.tableData.table_data[index].comments = comments;
    // this.loadData();
    this.data.pushTableUpdate(this.tableData.id);
  }


}
